import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { VerticalListArrow } from '../atoms/vertical_list_arrow';
import { useCss, useXlMediaQuery } from '@lean-body/src/util';
import { MediaBreakPointUp } from '../styles';
export const ITEM_WIDTH_SP = 152;
export const ITEM_WIDTH_OVER_XL = 310;
const ITEM_MARGIN_RIGHT = 12;
export const ITEMS_PADDING_RIGHT_AND_LEFT_SP = 48;
const ITEMS_PADDING_RIGHT_AND_LEFT_MD = 90;
const DEFAULT_SLIDE_PER_GROUP = 1;
export const VerticalListArrows = ({ items, itemsPadding, itemSize, itemMarginRight, slidePerGroup, isPageCount, classObject, pageCountClassObject, }) => {
    useCss('/assets/styles/swiper.css');
    const isXL = useXlMediaQuery();
    const [visible, setVisible] = React.useState(false);
    const navigationRight = 'swiper-navigation-right';
    const navigationLeft = 'swiper-navigation-left';
    const itemWidth = itemSize || (isXL ? ITEM_WIDTH_OVER_XL : ITEM_WIDTH_SP);
    let itemWidthWithPadding;
    if (Number.isInteger(itemsPadding)) {
        itemWidthWithPadding = itemWidth + itemsPadding;
    }
    else {
        itemWidthWithPadding = itemWidth + (isXL ? ITEMS_PADDING_RIGHT_AND_LEFT_MD : ITEMS_PADDING_RIGHT_AND_LEFT_SP);
    }
    const swiperModules = [Autoplay];
    if (isXL) {
        swiperModules.push(Navigation);
    }
    if (isPageCount) {
        swiperModules.push(Pagination);
    }
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.swipe), onMouseEnter: () => setVisible(true), onMouseLeave: () => setVisible(false) },
            React.createElement(Swiper, { modules: swiperModules, spaceBetween: itemMarginRight || ITEM_MARGIN_RIGHT, loop: false, width: itemWidthWithPadding, slidesPerGroup: slidePerGroup || DEFAULT_SLIDE_PER_GROUP, pagination: isPageCount && {
                    el: '.lesson-carousel-page-count',
                    type: 'fraction',
                }, navigation: {
                    prevEl: `.${navigationLeft}`,
                    nextEl: `.${navigationRight}`,
                    disabledClass: 'swiper-button-disabled',
                }, className: css(classObject) },
                items.map((v, i) => (React.createElement(SwiperSlide, { className: css(styles.swipeSlide), key: i }, v))),
                isXL && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: navigationLeft },
                        React.createElement(VerticalListArrow, { classObject: styles.navigation, visible: visible, direction: "prev" })),
                    React.createElement("div", { className: navigationRight },
                        React.createElement(VerticalListArrow, { classObject: styles.navigation, visible: visible, direction: "next" }))))),
            isPageCount && React.createElement("div", { className: `lesson-carousel-page-count ${css(styles.pageCount, pageCountClassObject)}` }))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
    },
    swipe: {
        width: '100%',
    },
    swipeSlide: {
        cursor: 'pointer',
    },
    navigation: {
        zIndex: 1,
    },
    pageCount: {
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: 12,
        paddingLeft: 20,
        paddingRight: 20,
        [MediaBreakPointUp.MD]: {
            paddingLeft: 34,
            paddingRight: 34,
        },
    },
});
